var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRacket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "circle_pieces",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "511.875px",
    height: "511.824px",
    viewBox: "0 0 511.875 511.824",
    enableBackground: "new 0 0 511.875 511.824",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "circle",
    fill: "#FFFFFF",
    cx: 256.252,
    cy: 255.986,
    r: 253.093
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "blue-piece",
    fill: "#3E5BA9",
    d: "M455.398,412.197c33.792-43.021,53.946-97.262,53.946-156.211 c0-139.779-113.313-253.093-253.093-253.093c-30.406,0-59.558,5.367-86.566,15.197C272.435,71.989,408.349,247.839,455.398,412.197z "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "left-red-piece",
    fill: "#9F1D20",
    d: "M220.003,164.337c-39.481-42.533-83.695-76.312-130.523-98.715 C36.573,112.011,3.159,180.092,3.159,255.986c0,63.814,23.626,122.104,62.597,166.623 C100.111,319.392,164.697,219.907,220.003,164.337z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "bottom-red-piece",
    fill: "#9F1D20",
    d: "M266.638,221.727c-54.792,59.051-109.392,162.422-129.152,257.794 c35.419,18.857,75.84,29.559,118.766,29.559c44.132,0,85.618-11.306,121.74-31.163C357.171,381.712,317.868,293.604,266.638,221.727 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRacket);
export default __webpack_public_path__ + "static/media/racket.826e8e4e963f4ad80f87eda9587507f1.svg";
export { ForwardRef as ReactComponent };